import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';

import { library } from '@fortawesome/fontawesome-svg-core'; 
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'; 
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import { faArrowTrendDown } from '@fortawesome/free-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import VueTypedJs from 'vue-typed-js'
import VueApexCharts from "vue3-apexcharts";
import './assets/custom.css?v=11';
import './registerServiceWorker';

library.add(faChevronLeft); 
library.add(faArrowTrendUp); 
library.add(faArrowTrendDown); 
library.add(faCircleInfo);
library.add(faBell);
library.add(faBellSlash);
library.add(faCircleCheck);
library.add(faClock);



import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const app = createApp(App); // Create app instance

app.use(router);
//app.config.globalProperties.emitter = emitter;
app.use(VueApexCharts);
app.use(Vue3Toastify, {
    autoClose: 8000,
    theme:"dark",
    "position": "top-right", 
  }); 
app.component('font-awesome-icon', FontAwesomeIcon); // Register globally
app.component('vue-typed-js', VueTypedJs);
app.mount('#app');
